import connect from '@vkontakte/vkui-connect';

export const isWebView = connect.supports('VKWebAppInit');



//////////////////
// WEBPACK FOOTER
// ./node_modules/@vkontakte/vkui/src/lib/webview.js
// module id = 98
// module chunks = 0